define('components/decorators/shareholder-information',[
    'jquery',
    'lib/shareholder_1.6.0.min',
    'components/decorator'
],function($, charts, decorator){
  var printButton = $('[data-print-button]');
  var printIcon = printButton.find('.ico-print');
  var spinnerIcon = printButton.find('.ico-spinner');

  function runOnlyTheLatest(fn) {
    var callIndex = 0;

    var wrapper = function wrapper() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      callIndex++;
      var currIndex = callIndex;
      return new Promise(function (yep, nope) {
        fn.apply(void 0, args).then(function (res) {
          if (currIndex === callIndex) {
            yep(res);
          } else {
            nope({
              cancelled: true
            });
          }
        }).catch(function (error) {
          if (currIndex === callIndex) {
            nope(error);
          } else {
            nope({
              cancelled: true,
              error: error
            });
          }
        });
      });
    };

    return wrapper;
  }

  function formatData(data) {
    if (data.relations) {
      data.relations.forEach(function(r) {
        if (r.percentage) {
          r.percentage = r.percentage / 100;
        }
      });
    }
    data.entities.forEach(function(e) {
      e.type =
        e.type === 'companies' && 'company' ||
        e.type === 'persons' && 'person' ||
        e.type === 'groups' && 'group' ||
        'unknown';
      e.uri = e._links &&
        e._links.profile &&
        e._links.profile.href || null;
    });
    return data;
  }

    function addLoader(el) {
        var $el = $(el);
        var height = $el.height();
        var width = $el.width();
        var loader = $('<div />');

        $(loader)
            .width(width)
            .height(height)
            .addClass('loader')
            .css('z-index', 0)
            .html('<span><i class="ico ico-spinner ico-spin"></i></span>')
            .prependTo($el);
    }

    function removeLoader(el) {
        $(el).find('.loader').remove();
    }

    /**
     * @param {function} fn - function that should be called when nrOfCalls param is equal to number of calls of this function
     * @param {number} nrOfCalls - number of calls after which fn() should be called
     */
    function callWhenAllDone(fn, nrOfCalls) {
      var n = 0;
      return function() {
        n++;

        if (n === nrOfCalls) {
          return fn();
        }
      };
    }

    // Enable print button only after all API calls for shareholder info are finished
    var enablePrintButtonIfAllLoaded = callWhenAllDone(function() {
      printButton.attr('disabled', false);
      spinnerIcon.css('display', 'none');
      printIcon.css('display', 'block');
    }, 3);

    function showLastUpdateDate(date) {
      var lastUpdateDateContainer = $('.shareholder-last-update-date');
      var dateEl = lastUpdateDateContainer.find('.date');
      if (dateEl.length) return; // Return if date is already added
      var newDate = new Date(date);
      if (newDate == 'Invalid Date') return;

      var dateString = newDate.toLocaleString(window.companyInfo.lang,  { year: 'numeric', month: 'long' });
      lastUpdateDateContainer.append('<span class="date">' + dateString + '</span>');
      lastUpdateDateContainer.removeClass('hidden');
    }

    function formatPercentage(num) {
      var locale = d3.formatLocale(window.companyInfo.lang === 'de' ? {
        "decimal": ",",
        "thousands": ".",
        "grouping": [3],
        "currency": ["", "\u00a0€"]
      } : {
        "decimal": ".",
        "thousands": ",",
        "grouping": [3],
        "currency": ["", "\u00a0€"]
      });
      var format = locale.format('.2%');
      var formatted = format(num);
      return num < 0.001 ? '< 0.10%' : formatted;
    }


  var getGraphDataFor = function (params) {
    if (!params.cin) {
      return Promise.resolve(null);
    }
    var queryParams = ['cin=' + params.cin];
    if (params.inbound || params.outbound) {
      queryParams.push('inbound_depth=' + (params.inbound || '0'));
      queryParams.push('outbound_depth=' + (params.outbound || '0'));
    }
    if (params.details) {
      queryParams.push('additional_information=true&ci_links=true');
    }
    if (params.destination) {
      queryParams.push('destination_cin=' + params.destination);
    }
    if (params.threshold) {
      queryParams.push('percentage_threshold=' + params.threshold);
    }
    var url = '/ws-api/shareholder/graph?' + queryParams.join('&');
    return d3.json(url);
  };

  var getOnlyLatestGraphDataFor = runOnlyTheLatest(getGraphDataFor);

  $.extend(companyInfo.decorators, {
    'shareholder-information': function (e) {
            var shareholderPanel = $('.shareholder-information');
            var shareholderGraphContainer = $('.shareholder-information__graph-container');
            var shareholderGraph = $('.shareholder-information__graph');
            var expanderButton = shareholderPanel.find('button.expand-button');
            var resetButton = shareholderPanel.find('button.reset-button');
            var bvaCheckbox = shareholderPanel.find('.bva-checkbox input');
            var expanderIcon = expanderButton.find('.ico');
            var unknownUboMessage = $('.shareholder-information__unknownubo');
            unknownUboMessage.hide();
            var initialGraphPosition = {};
            var isExpanded = false;
            var activeChart = 'shareholder';
            var showBVA = false;

            var shareHolderChart = new charts.ShareHolder(shareholderGraph.get(0));
            shareHolderChart.lang(companyInfo.lang);
            shareHolderChart.onNodeClick(function(node, heading) {
                var inboundDepth =
                    heading === 'parents' ? 3 :
                    heading === 'bva' ? 10 :
                    '';
                var outboundDepth =
                    heading === 'children' ? 3 :
                    heading === 'bva' ? 0 :
                    '';

                if (node.type === 'company') {
                    return loadDataFor(node.cin, false, inboundDepth, outboundDepth, node.id);
                }
                if (node.type === 'more' && node.childrenNr) {
                    var firstLevelNode = node.parent.parent;
                    loadDataFor(firstLevelNode.data.cin, false, inboundDepth, outboundDepth, firstLevelNode.id);
                }
            });
            shareHolderChart.onHeadingClick(function(heading) {
                var cin = heading.main_cin;
                var name = heading.name;
                var isParents = name === 'parents';
                var isChildren = name === 'children';
                loadDataFor(cin, false, isParents ? 3 : name === '' ? '' : 0, isChildren ? 3 : name === '' ? '' : 0);
            });
            var uboChart;

            resizeChart();

            $(window).on('resize', function() {
                if (activeChart === 'shareholder') {
                    return resizeChart();
                }
                if (activeChart === 'ubo') {
                    return uboChartResize();
                }
            });

            var currentOrgKey = shareholderGraph.data('follow-key');
            if(currentOrgKey) {
                loadDataFor(currentOrgKey, true);
                initSignificantShareholders(currentOrgKey);
            }

            function resizeChart(hide) {
                var w = shareholderGraph.width();
                var h = shareholderGraph.height();
                if (hide === true) {
                    return shareHolderChart.resize(0, 0);
                }
                shareHolderChart.resize(w, h);
            }

            function uboChartResize(hide) {
                var w = shareholderGraph.width();
                var h = shareholderGraph.height();
                if (hide) {
                    return uboChart.resize(0, 0);
                }
                uboChart.resize(w, h);
            }

            function addPrintView(data) {
              if (!data) return;

              var entities = data.entities;
              var relations = data.relations;
              var printTableBody = $('.shareholder-information__graph--print > tbody');

              var shareholders = getCompaniesOfType('shareholder', currentOrgKey, entities, relations);
              var participations = getCompaniesOfType('participation', currentOrgKey, entities, relations);

              if (shareholders.length || participations.length) {
                var totalRows = Math.max(shareholders.length, participations.length);
                var rowsMarkup = [];

                // Append values to table
                for(var row = 0; row < totalRows; row++) {
                  var shareholder = shareholders[row];
                  var participation = participations[row];

                  var shareholderText = shareholder ? (shareholder.percentage ? formatPercentage(shareholder.percentage / 100) + ' ' + shareholder.name : shareholder.name) : '';
                  var participationText = participation
                    ? (participation.percentage ? formatPercentage(participation.percentage / 100) + (window.companyInfo.lang === 'en' ? ' of ' : ' von ') + participation.name : participation.name)
                    : '';
                  rowsMarkup.push(
                    '<tr>' +
                      '<td>' + shareholderText + '</td>' +
                      '<td>' + participationText + '</td>' +
                    '</tr>'
                  );
                }

                printTableBody.append(rowsMarkup.join(''));
              }
            }

            function getCompaniesOfType(type, mainCompanyId, entities, relations) {
              if (!type || !mainCompanyId || !entities || !relations) return [];

              var isTypeParticipation = type === 'participation';
              var isTypeShareholder = type === 'shareholder';

              return relations
                .filter(function(r) {
                  if (isTypeShareholder) {
                    return r.to === mainCompanyId;
                  }
                  if (isTypeParticipation) {
                    return r.from === mainCompanyId;
                  }
                })
                .sort(function(a, b) {
                  return b.percentage - a.percentage;
                })
                .map(function(r) {
                  var id = isTypeShareholder ? r.from : r.to;
                  var entity = entities.find(function(e) {
                    return e.cin === id;
                  });
                  return {
                    type: type,
                    percentage: r.percentage,
                    name: entity.name
                  };
                });
            }

            function hidePrintView() {
              $('.shareholder-information__graph--print').hide();
            }

            function loadDataFor(followKey, initial, inbound, outbound, id) {
                addLoader(shareholderGraph);
                disableButtons();
                getOnlyLatestGraphDataFor({cin: followKey, inbound: inbound, outbound: outbound, details: true})
                    .then(function(companySHData) {
                        if (!companySHData.entities || !companySHData.relations) {
                            if (initial) {
                                shareholderPanel.hide();
                            } else {
                                removeLoader(shareholderGraph);
                            }
                            return;
                        }
                        showLastUpdateDate(companySHData.update_date);
                        removeLoader(shareholderGraph);
                        addPrintView(companySHData);
                        return shareHolderChart.data(formatData(companySHData), id);
                    })
                    .then(function() {
                        shareHolderChart.changeZoomExtent();
                        enableButtons();
                    })
                    .catch(function (err) {
                        if (!err.cancelled && initial) {
                            shareholderPanel.hide();
                            hidePrintView();
                        }
                    })
                    .finally(function(d) {
                      enablePrintButtonIfAllLoaded();
                    });
            }


            bvaCheckbox.on('change', function() {
                var checkbox = $(this);
                showBVA = checkbox.prop('checked');


                shareHolderChart
                    .showBVA(showBVA)
                    .then(function() {
                        if (showBVA) {
                            loadDataFor(currentOrgKey, false, 10, 0);
                        } else {
                            loadDataFor(currentOrgKey);
                        }
                    });
            });

            resetButton.on('click', function() {
                if (activeChart === 'ubo') {
                    var activeListItem = $('.shareholder-information__list').find('.toggle-ubo');
                    switchToShareholderChart(activeListItem);
                }

                disableButtons();
                addLoader(shareholderGraph);
                bvaCheckbox.prop('checked', false);

                // Load initial view
                getOnlyLatestGraphDataFor({cin: currentOrgKey, details: true})
                    .then(function(data) {
                        if (!data.entities || !data.relations) {
                            removeLoader(shareholderGraph);
                            return;
                        }
                        removeLoader(shareholderGraph);
                        shareHolderChart.resetZoomWithoutRedraw();
                        return shareHolderChart.displayInitialView(formatData(data), currentOrgKey);
                    })
                    .then(function() {
                        // After transition finishes
                        shareHolderChart.changeZoom();
                        shareHolderChart.changeZoomExtent();
                        enableButtons();
                    });
            });

            function switchToShareholderChart(activeListItem) {
                removeLoader(shareholderGraph);
                uboChartResize(true); // hide ubo chart
                activeListItem.removeClass('toggle-ubo');
                activeChart = 'shareholder';
                return resizeChart();
            }

            function enableButtons() {
                resetButton.attr('disabled', false);
                expanderButton.attr('disabled', false);
                bvaCheckbox.attr('disabled', false);
            }

            function disableButtons() {
                resetButton.attr('disabled', true);
                expanderButton.attr('disabled', true);
                bvaCheckbox.attr('disabled', true);
            }

            expanderButton.on('click', function() {
                if (isExpanded) return minimizeGraph(shareholderGraphContainer);

                var graphPosition = getGraphPosition();
                initialGraphPosition = graphPosition;

                shareholderGraphContainer.css({
                    position: 'fixed',
                    top: graphPosition.top + 'px',
                    left: graphPosition.left + 'px',
                    height: graphPosition.height,
                    width: graphPosition.width,
                    marginTop: 0,
                    backgroundColor: 'white',
                    zIndex: '9999'
                });

                shareholderGraph.css({
                    marginTop: 0
                });

                // Expand graph
                shareholderGraphContainer.animate({
                    top: '60px',
                    left: 0,
                    height: $(window).height() - 60,
                    width: '100vw'
                }, (function () {
                    var vw = $(window).width();
                    var w = 0;
                    var h = 0;
                    return {
                        duration: 300,
                        step: function(_, tween) {
                            if (tween.prop === 'width') {
                               w = vw * tween.now / 100;
                            }

                            if (tween.prop === 'height') {
                                h = tween.now - 34;
                            }
                        },
                        progress: function() {
                            activeChart === 'shareholder' && shareHolderChart.resize(w, h);
                            activeChart === 'ubo' && uboChart.resize(w, h);
                        },
                        done: function() {
                            shareholderGraphContainer.css('height', 'calc(100vh - 60px)');
                        }
                    };
                })());

                $('html').css('overflow-y', 'hidden');
                expanderIcon.removeClass('ico-expand');
                expanderIcon.addClass('ico-minus');
                isExpanded = true;
            });

            function getGraphPosition() {
                var shareholderGraphContainer = $('.shareholder-information__graph-container');
                return shareholderGraphContainer.get(0).getBoundingClientRect();
            }

            function minimizeGraph(shareholderGraphContainer) {
                // Reset zoom level when minimizing
                activeChart === 'shareholder' ? shareHolderChart.resetZoom() : uboChart.resetZoom();
                // Return graph to initial position
                shareholderGraphContainer.animate(
                    setPosition(initialGraphPosition), (function() {
                        var w = 0;
                        var h = 0;
                        return {
                            duration: 300,
                            done: function() {
                                shareholderGraphContainer.css({
                                    position: '',
                                    marginTop: '',
                                    backgroundColor: '',
                                    zIndex: ''
                                });

                                shareholderGraph.css({
                                    marginTop: ''
                                });
                            },
                            step: function(now, tween) {
                                if (tween.prop === 'width') {
                                    w = now;
                                }
                                if (tween.prop === 'height') {
                                    h = now - 44;
                                }
                            },
                            progress: function () {
                                activeChart === 'shareholder' && shareHolderChart.resize(w, h);
                                activeChart === 'ubo' && uboChart.resize(w, h);
                            }
                        };
                    })());

                $('html').css('overflow-y', 'visible');
                expanderIcon.removeClass('ico-minus');
                expanderIcon.addClass('ico-expand');
                isExpanded = false;
            }

            function setPosition(prevPosition) {
                return {
                    top: prevPosition.top,
                    left: prevPosition.left,
                    height: prevPosition.height,
                    width: prevPosition.width
                };
            }

            function initSignificantShareholders(orgKey) {
                var sigShareholderContainer = $('.shareholder-information__list-container');
                var sigShareholderList = $('.shareholder-information__list');
                var prevId;
                sigShareholderList.on('click', '.shareholder-information__shareholder', function(e) {
                    var shareholderButton = $(this);
                    var uboSVG = $('svg.ci-ultimate-shareholders');
                    var id = shareholderButton.attr('id');
                    var depth = shareholderButton.data('depth');
                    // If shareholder with same id is clicked again, display shareholder graph
                    if (prevId === id && activeChart !== 'shareholder') {
                        return switchToShareholderChart(shareholderButton);
                    }
                    prevId = id;
                    addLoader(shareholderGraph);
                    disableButtons();
                    shareholderButton.css('pointer-events', 'none');
                    // find if there are already selected ones, remove toggle class
                    $('.toggle-ubo').each(function(i, e) {
                        $(e).removeClass('toggle-ubo');
                    });
                    shareholderButton.toggleClass('toggle-ubo');

                    // remove previous ubo chart
                    uboSVG.remove();

                    uboChart = new charts.UBO(shareholderGraph.get(0));
                    uboChart.lang(companyInfo.lang);
                    resizeChart(true); // hide shareholder chart
                    // Add new ubo chart and data
                    //TODO load from backend with loadUboChartData(id, currentOrgKey);
                    getOnlyLatestGraphDataFor({cin: id, outbound: depth, destination: orgKey, details: true})
                      .then(function (uboData) {
                        uboChart.data(formatData(uboData));
                        removeLoader(shareholderGraph);
                        enableButtons();
                        shareholderButton.css('pointer-events', 'auto');
                        uboChartResize();
                        activeChart = 'ubo';
                      });
                });

                addLoader(sigShareholderList);
                d3.json('/ws-api/shareholder/ultimate-shareholder?cin=' + orgKey + '&additional_information=true&ci_link=true')
                    .then(function(data) {
                        if (data.shareholders && data.shareholders.length) {
                            var listHtml = data.shareholders.map(function (s) {
                                var profileLink = makeProfileLink(s);
                                return '' +
                                '<div class="shareholder-information__shareholder" id="' + s.cin + '" data-depth="' + s.max_depth + '"' +  (profileLink ? 'data-tooltip-trigger' : '') + '>' +
                                '  <div class="shareholder-information__shareholder-icon">' +
                                '    <i class="ico ico-' + iconForEntityType(s.type) + '" aria-hidden="true"></i>' +
                                '  </div>' +
                                '  <div class="shareholder-information__shareholder-name">' +
                                '    <span>' + s.name + '</span>' +
                                '  </div>' +
                                '  <div class="shareholder-information__shareholder-percentage">' +
                                '    <span>' + (s.calculated_percentage ? formatPercentage(s.calculated_percentage / 100) : '') + '</span>' +
                                '  </div>' +
                                '  <div>' + profileLink + '</div>' +
                                '  <div class="shareholder-information__link-to-ubo"><i class="ico ico-chevron-right"></i></div>' +
                                '</div>';
                                }).join('');
                            sigShareholderList.append(listHtml);
                            removeLoader(sigShareholderList);
                        } else {
                            sigShareholderList.hide();
                            unknownUboMessage.show();
                        }
                        sigShareholderContainer.removeAttr('data-decorated');
                        decorator.run(sigShareholderContainer.parent());
                    })
                    .catch(function() {
                        sigShareholderList.hide();
                        unknownUboMessage.show();
                    })
                    .finally(function() {
                      enablePrintButtonIfAllLoaded();
                    });
            }

        // Making link (if data is there) that will go to german or international profile page
        function makeProfileLink(info) {
            if (info  && info.additional_information) {
                if (info.type === 'companies') {
                    var additionalInfo = info.additional_information;
                    var country = additionalInfo.country;

                    if (country && country.toLowerCase() === 'de' && info._link && info._link.profile && info._link.profile.href) {
                        return info.cin ? '<a data-tooltip-content class="hidden" href="' + info._link.profile.href + '">' + info.name + '</a>' : '';
                    }

                    if (country && country.toLowerCase() !== 'de') {
                        return additionalInfo.international_id ? '<a data-tooltip-content class="hidden" href="/int/' + additionalInfo.international_id + '">' + info.name + '</a>' : '';
                    }
                } else {
                    var firstName = info.name.split(', ')[1];
                    var lastName = info.name.split(', ')[0];
                    if(window.companyInfo.lang === 'en') {
                        return '<a data-tooltip-content class="hidden" href="/prepare/searchcompliance/persons/'
                            + lastName + '/' + firstName + '">Compliance check</a>';
                    } else {
                        return '<a data-tooltip-content class="hidden" href="/prepare/searchcompliance/persons/'
                            + lastName + '/' + firstName + '">Compliance Checken</a>';
                    }
                }
            }
            return '';
        }

            function iconForEntityType(type) {
                return type === 'companies' && 'building' ||
                    type === 'persons' && 'user' ||
                    type === 'groups' && 'users' ||
                    'question';
            }
        },
        'shareholder-fifty': function() {
            var panel = $('.shareholder-fifty');
            var panelContent = $('.shareholder-fifty .panel-content');
            var chart = new charts.FiftyPercent(panelContent.get(0));
            chart.lang(companyInfo.lang);
            var expanderButton = panel.find('.expander');
            var expanderIcon = expanderButton.find('.ico');

            resizeChart();

            expanderButton.on('click', toggleView);

            var currentOrgKey = panelContent.data('follow-key');
            if(currentOrgKey) {
                loadDataFor(currentOrgKey);
            }

            function resizeChart() {
                var w = panelContent.width();
                var h = panelContent.height();
                chart.resize(w, h);
            }

            function addPrintView(data) {
              if (!data) return;

              var printTableBody = $('.shareholder-fifty--print > tbody');
              var hierarchy = makeHierarchy(data);

              // Adding additional info to hierarchy data
              hierarchy.each(function(n) {
                if (n.children) {
                  n.children[n.children.length - 1].isLast = true;
                }
              });

              // Adding rows to print table
              hierarchy.eachBefore(function(node) {
                var content = makeTreeViewRowData(node);

                printTableBody.append(
                  '<tr>' +
                    '<td>' +
                      '<div>' +
                        content +
                      '</div>' +
                    '</td>' +
                  '</tr>'
                );
              });
            }

            // Adding line images and text that will be shown per row
            function makeTreeViewRowData(node) {
              var level = node.depth;
              var content = ''; // Table cell content

              // If first company just return name
              if (level === 0) {
                return '<span>'
                  + (node.data.cin === currentOrgKey ? '<b style="text-decoration: underline">' + node.data.name + '</b>' : node.data.name) +
                  '</span>';
              }

              // First get all ancestors of current node starting from top one
              var ancestors = node.ancestors()
                .filter(function(ancestor) {
                  return ancestor.data.cin !== node.data.cin && ancestor.depth !== 0;
                })
                .sort(function(a, b) {
                  return a.depth - b.depth;
                });

              // Add connecting lines for ancestors
              if (ancestors && ancestors.length) {
                ancestors.forEach(function(ancestor) {
                  if (!ancestor.isLast) { // Add connecting line only if there are more siblings
                    content += '<img src="/gui/img/line-straight.png" />'; // │
                  } else {
                    content += '<img class="print-hidden" width="17" />'; // Indent
                  }
                });
              }

              // Add connecting line to current node
              if (node.isLast) {
                content += '<img src="/gui/img/line-last.png" />'; // └
              } else {
                content += '<img src="/gui/img/line-connect.png" />'; // ├
              }

              // Add cell text at the end
              var cellText = node.data.owned ? node.data.name + ' ' + '(' + formatPercentage(node.data.owned) + ')' : node.data.name;
              content += '<span>'
                  + (node.data.cin === currentOrgKey ? '<b style="text-decoration: underline">' + cellText + '</b>' : cellText) +
                '</span>';

              return content;
            }

            function hidePrintView() {
              $('.shareholder-fifty--print').hide();
            }

            function makeHierarchy(data) {
              var entities = data.entities;
              var relations = data.relations;
              var ancestorId = data.from_cin;

              var nodesHash = entities.reduce(function(acc, c){
                acc[c.cin] = c;
                return acc;
              }, {});

              relations.forEach(function(r) {
                nodesHash[r.to].owned = r.percentage;
              });

              return d3.hierarchy(nodesHash[ancestorId], function(n) {
                return relations
                  .filter(function(r){
                    return r.from === n.cin;
                  })
                  .map(function(r) {
                    return nodesHash[r.to];
                  })
                  .sort(function(a, b) {
                    return stringCompare(a.name, b.name, 'de');
                  });
              });
            }

            function stringCompare(a, b, locale) {
              if (String.prototype.localeCompare) {
                if (a !== null && a !== undefined) {
                  return a.localeCompare(b, locale, {sensitivity: 'base'});
                } else {
                  return b === null || b === undefined ? 0 : -1;
                }
              }

              if (a > b) return 1;
              if (b > a) return -1;

              return 0;
            }


          function loadDataFor(orgKey) {
                addLoader(panelContent);
                expanderButton.attr('disabled', true);
                getMajorityShareholder(orgKey)
                    .then(function(data) {
                        var ancesstor = findAncesstor(data);
                        return getMajorityParticipations(ancesstor).then(function(data) {
                            if (data.entities.length === 1) {
                               $('.shareholder-fifty').parent().hide();
                            } else {
                                $(window).on('resize', resizeChart);
                                data.target_cin = orgKey;
                                chart.data(formatData(data));
                                showLastUpdateDate(data.update_date);
                                removeLoader(panelContent);
                                expanderButton.attr('disabled', false);
                                addPrintView(data);
                            }
                        })
                        .catch(function() {
                            $('.shareholder-fifty').parent().hide();
                            hidePrintView();
                        });
                    })
                    .catch(function() {
                      $('.shareholder-fifty').parent().hide();
                    })
                    .finally(function(e) {
                      enablePrintButtonIfAllLoaded();
                    });
            }

            function getMajorityShareholder(key) {
              return getGraphDataFor({
                cin: key,
                inbound: 97, //just a nice high number
                threshold: 50
              });
            }

            function getMajorityParticipations(key) {
              return getGraphDataFor({
                cin: key,
                outbound: 97, //just a nice high number
                threshold: 50,
                details: true
              });
            }

            function findAncesstor(data) {
                if (!data.relations || !data.relations.length) {
                    return data.from_cin;
                }
                var parents = data.relations.reduce(function(acc, c) {
                    acc[c.to] = c.from;
                    return acc;
                }, {});
                var entities = data.entities.reduce(function(acc, c) {
                    acc[c.cin] = c;
                    return acc;
                }, {});
                var ancesstor = data.from_cin;
                while(parents[ancesstor] &&
                    (entities[parents[ancesstor]].type === 'companies' ||
                    entities[parents[ancesstor]].type === 'persons')) {
                    ancesstor = parents[ancesstor];
                }

                return ancesstor;
            }

            var initialGraphPosition = null;
            function toggleView() {
                if (initialGraphPosition === null) {
                    expand();
                } else {
                    collapse();
                }
            }

            function expand() {
                initialGraphPosition = panel.get(0).getBoundingClientRect();
                var graphPosition = initialGraphPosition;

                panel.css({
                    position: 'fixed',
                    top: graphPosition.top + 'px',
                    left: graphPosition.left + 'px',
                    height: graphPosition.height,
                    width: graphPosition.width,
                    marginTop: 0,
                    backgroundColor: 'white',
                    zIndex: '9999'
                });
                panelContent.css({marginTop: 0});

                $('html').css('overflow-y', 'hidden');
                panel.animate({
                    top: '60px',
                    left: 0,
                    height: $(window).height() - 60,
                    width: '100vw',
                    padding: 0,
                }, (function () {
                    var vw = $(window).width();
                    var w = 0;
                    var h = 0;
                    return {
                        duration: 300,
                        step: function(_, tween) {
                            if (tween.prop === 'width') {
                                w = vw * tween.now / 100;
                            }

                            if (tween.prop === 'height') {
                                h = tween.now - 34;
                            }
                        },
                        progress: function() {
                            chart.resize(w, h);
                        },
                        done: function() {
                            panel.css('height', 'calc(100vh - 60px)');
                        }
                    };
                })());

                expanderIcon.removeClass('ico-expand');
                expanderIcon.addClass('ico-minus');
            }

            function collapse() {
                chart.resetZoom();
                
                panel.css({padding: ''});
                panel.animate({
                    top: initialGraphPosition.top + 'px',
                    left: initialGraphPosition.left + 'px',
                    height: initialGraphPosition.height,
                    width: initialGraphPosition.width,
                }, (function() {
                    var w = 0;
                    var h = 0;
                    return {
                        duration: 300,
                        step: function (now, tween) {
                            if (tween.prop === 'width') {
                                w = now;
                            }
                            if (tween.prop === 'height') {
                                h = now - 44;
                            }
                        },
                        progress: function () {
                            chart.resize(w, h);
                        },
                        done: function () {
                            panel.css({
                                position: '',
                                marginTop: '',
                                backgroundColor: '',
                                zIndex: '',
                                width: '',
                                height: '',
                                top: '',
                                left: '',
                            });

                            panelContent.css({
                                marginTop: ''
                            });

                            resizeChart();
                        },
                    };
                })());
                $('html').css('overflow-y', '');
                expanderIcon.removeClass('ico-minus');
                expanderIcon.addClass('ico-expand');
                initialGraphPosition = null;
            }
        }
    });
});

